import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { ReactComponent as ArrowDown } from "../../../images/svg/arrow-down.svg";
import { getMagazines } from "./service";

const MagazinePage = () => {
    const location = useLocation();
    const { pathname } = location;
    const [data, setData] = useState(location.state?.data || null);
    const [loading, setLoading] = useState(!data);
  
    useEffect(() => {
      if (!data) {
        setLoading(true);
        getMagazines().then((response) => {
          if (response?.success) {
            const magazine = response.data.find((item) => {
              if (pathname.includes("LifeIsImportant")) {
                return item.name === "Life is Important";
              } else if (pathname.includes("BBCGodHelpUs")) {
                return item.name === "BBC God Help US!";
              }
              return false;
            });
            setData(magazine);
          }
          setLoading(false);
        });
      }
    }, [data, pathname]);
  
    if (loading) {
      return <div>Loading...</div>;
    }
  
    if (!data) {
      return <div>Magazine not found.</div>;
    }

  return (
    <div className="subscribe">
      <div className="wrapper">
        <div className="subscribeContainer">
          <h1 className="heading">{data?.name || data?.show_name}</h1>
          <div className="magazineSection">
            <div className="left">
              <div className="imageContainer">
                <img src={data?.image || data?.logo} alt="Magazine" />
              </div>
            </div>
            <div className="right">
              <h1>
                Please Download here for FREE or Call the revelation office to
                order a printed booklet.
                <br />
                0208 972 1400 (Mon-Friday 9am to 5:30pm)
              </h1>
              <div className="downloadbuttonContainer">
                <button onClick={() => window.open(data.url, "_blank")}>
                  <ArrowDown />
                  Download
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MagazinePage;
